import axios from "../app/axios"

export default  (username,password,twoFactorCode) =>{
    return axios({redirect401:false}).post("/login",{username:username,password:password,twoFactorCode:twoFactorCode});
}